import React, { createContext, useContext, useState, useEffect } from 'react';
import useSnackbar from "customHooks/useSnackbar";
import useConfirmDialog from "customHooks/useConfirmDialog";
import { useLocation } from 'react-router-dom'
import axiosInstance from "../common/axiosInstance";

const AppContext = createContext();

export const useAppContext = () => useContext(AppContext);

export default ({ children }) => {
  const { message, handleClose, openSnackbar, severity, handleShow } = useSnackbar();
  const { contentDialog, handleCloseDialog, openDialog, okBtn, hideCancelBtn,
    titleDialog, handleShowDialog, onOkDialog, cancelBtn, isReverse } = useConfirmDialog();
  const location = useLocation();
  const [fnol, setFnol] = useState('');
  const [msg, setMsg] = useState('');
  const [route, setRoute] = useState({
    to: location.pathname,
    from: location.pathname,
  });
  const [homeData, setHomeData] = useState({
    sliders: [],
    products: [],
    purposes: [],
    partners: [],
    loaded: false,
  });
  const [isLoading, setLoading] = useState(0);
  const handleLoading = (loading = true) => {
    if (loading) {
      setLoading((prev) => prev + 1);
      return;
    }
    setLoading((prev) => prev - 1);
  };

  useEffect(() => {
    setRoute((prev) => ({ to: location.pathname, from: prev.to }))
  }, [location]);

  useEffect(()=>{
    loadHomeData()
  },[])

  const doChangeFnol = (fnol) => {
    setFnol(fnol);
  }

  const loadHomeData = () => {
    if (homeData.loaded) return;
    handleLoading(true)
    const getSliders = () => {
      return axiosInstance
      .get("/get-sliders")
    };
    // const getProduct = () => {
    //   return axiosInstance
    //   .get("/get-sliders-product")
    // };
    const getPurpose = () => {
      return axiosInstance
      .get("/get-why-choose-baohiemso")
    };
    const getPartner = () => {
      return axiosInstance
      .get("/get-sliders-partner")
    };
    Promise.all([
      getSliders(),
      // getProduct(),
      getPurpose(),
      getPartner(),
    ])
      .then((values) => {
        setHomeData({
          sliders: values[0],
          // products: values[1],
          purposes: values[1],
          partners: values[2],
          loaded: true,
        })
      })
      .finally(() => {
        handleLoading(false);
      });
  }

  const setUserInfo = (user) => {
    if (!user) return;
    localStorage.setItem('user', JSON.stringify(user));
  }
  const getUserInfo = () => {
    const user = localStorage.getItem('user');
    if (user) {
      return JSON.parse(user)
    }
    return null
  }

  return (
    <AppContext.Provider value={{
      fnol, doChangeFnol,
      snackbar: {
        message, handleClose, openSnackbar, severity, handleShow
      },
      confirmDialog: {
        contentDialog, handleCloseDialog, openDialog, okBtn,
        titleDialog, handleShowDialog, onOkDialog, hideCancelBtn, cancelBtn, isReverse
      },
      msg,
      setMsg,
      route,
      getUserInfo,
      setUserInfo,
      homeData,
      isLoading,
    }}>
      {children}
    </AppContext.Provider>
  );
};
